import { useEffect, useState } from 'react';

const TRACKING_DELAY = 2000;

const useLoadTracking = (onLoad?: () => void) => {
  const [load, setLoad] = useState(false);
  useEffect(() => {
    let timeout: number, listening: boolean;
    const onload = () => {
      timeout = window.setTimeout(() => {
        setLoad(true);
        onLoad?.();
      }, TRACKING_DELAY);
    };
    if (document.readyState === 'complete') {
      onload();
    } else {
      listening = true;
      window.addEventListener('load', onload);
    }
    return () => {
      timeout && clearTimeout(timeout);
      listening && window.removeEventListener('load', onload);
    };
  }, [onLoad]);
  return { load };
};

export default useLoadTracking;
